import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["aria-label"]

import LocaleLink from '@/components/feedback/LocaleLink.vue';
import BotRoomButton from '@/pages/lobby/BotRoomButton.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'WikiPlayCta',
  props: {
    showRules: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("aside", {
    class: "wiki-play-cta",
    "aria-label": _ctx.$t('wikiPlay.title')
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.$t('wikiPlay.title')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('wikiPlay.description')), 1)
    ]),
    _createElementVNode("nav", {
      "aria-label": _ctx.$t('wikiPlay.title')
    }, [
      _createVNode(LocaleLink, {
        class: "play-link",
        to: { name: 'lobby' }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wikiPlay.play')), 1)
        ]),
        _: 1
      }),
      _createVNode(BotRoomButton, {
        variant: "outlined",
        color: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('wikiPlay.playAi')), 1)
        ]),
        _: 1
      }),
      (_ctx.showRules)
        ? (_openBlock(), _createBlock(LocaleLink, {
            key: 0,
            to: { name: 'rules' }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('wikiPlay.rules')), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ], 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})